import React, { useState } from "react";
import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { PieChart, Pie, Cell } from "recharts";
import { addThousandsSeparator } from "../../../utils/helper";
import {
  blackShade19,
  greyColor56,
  greyColor57,
} from "../../../configs/styles/muiThemes";
import OrderAnalysisEmptyCard from "../Cards/OrderAnalysisEmptyCard";
import moment from "moment";

function OrderSaleByTypeYearSection({ orderSalesByType }) {
  const [selectedYear, setSelectedYear] = useState(2025);

  // Update data based on the selected year
  const selectedData = orderSalesByType?.find(
    (item) => item?.year === selectedYear
  );

  const data = [
    {
      name: "ONDC Order",
      value: selectedData?.ondcOrderSales,
      color: "#FFBB28",
    },
    {
      name: "Website Order",
      value: selectedData?.websiteOrderSales,
      color: "#00C49F",
    },
  ];
  const totalSales =
    selectedData?.ondcOrderSales + selectedData?.websiteOrderSales;

  const handlePrevYear = () => {
    const prevYear = selectedYear > 2022 ? selectedYear - 1 : 2022;
    setSelectedYear(prevYear);
  };

  const handleNextYear = () => {
    const currentYear = moment().year();
    const nextYear =
      selectedYear < currentYear ? selectedYear + 1 : currentYear;
    setSelectedYear(nextYear);
  };
  return (
    <Box
      sx={{
        border: "1px solid " + greyColor56,
        borderRadius: "12px",
        overflow: "hidden",
        textAlign: "center",
        p: 1.5,
      }}
      minHeight={"100%"}
    >
      {/* Header with Navigation */}
      <Grid container justifyContent="space-between" alignItems="center">
        <IconButton
          sx={{
            width: "26px",
            height: "26px",
            backgroundColor: "rgb(250, 250, 250)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            border: "1px solid rgb(232, 232, 232)",
            cursor: "pointer",
          }}
          onClick={handlePrevYear}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: "12px", color: greyColor57 }} />
        </IconButton>
        <Typography variant="h6" fontWeight={600}>
          Year - {selectedYear}
        </Typography>
        <IconButton
          sx={{
            width: "26px",
            height: "26px",
            backgroundColor: "rgb(250, 250, 250)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            border: "1px solid rgb(232, 232, 232)",
            cursor: "pointer",
          }}
          onClick={handleNextYear}
        >
          <ArrowForwardIosIcon sx={{ fontSize: "12px", color: greyColor57 }} />
        </IconButton>
      </Grid>

      {/* Pie Chart */}
      {selectedData?.ondcOrderCount > 0 ||
      selectedData?.websiteOrderCount > 0 ? (
        <Box display={"flex"} gap={5} mt={5}>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <PieChart width={150} height={150}>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={75}
                paddingAngle={-10}
                cornerRadius={10}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>

            {/* Centered Sales Info */}
            <Box
              sx={{
                position: "absolute",
                textAlign: "center",
                mt: "60px",
              }}
            >
              <Typography variant="h5" fontWeight={600}>
                ₹ {addThousandsSeparator(totalSales)}
              </Typography>
              <Typography color="gray">Total Sales</Typography>
            </Box>
          </Box>

          {/* Order Details */}
          <Stack gap={2} sx={{ mt: 3, textAlign: "left" }}>
            {data?.map((item, index) => (
              <Box display={"flex"} flexDirection={"column"}>
                <Box
                  key={index}
                  sx={{ display: "flex", alignItems: "center" }}
                  // mt={2}
                >
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: item?.color,
                      mr: 1,
                    }}
                  />
                  <Typography variant="body2" fontSize={12.5} color="gray">
                    {item?.name}
                  </Typography>
                </Box>
                <Box ml={2.5}>
                  <Box display={"flex"} alignItems={"center"} gap={1}>
                    {/* <Typography variant="h1" fontSize={12}> Orders :</Typography> */}
                    <Typography
                      color={blackShade19}
                      fontSize={13}
                      fontWeight={600}
                    >
                      {item.name === "ONDC Order"
                        ? selectedData?.ondcOrderCount
                        : selectedData?.websiteOrderCount}
                    </Typography>
                  </Box>
                  <Typography
                    color={blackShade19}
                    fontSize={13}
                    fontWeight={600}
                  >
                    ₹{" "}
                    {item.name === "ONDC Order"
                      ? addThousandsSeparator(selectedData?.ondcOrderSales)
                      : addThousandsSeparator(selectedData?.websiteOrderSales)}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      ) : (
        <Box height="145px">
          <OrderAnalysisEmptyCard mt="25px" />
        </Box>
      )}
    </Box>
  );
}

export default OrderSaleByTypeYearSection;
